// Keep: Add back when launch happens - import
// import { LandingBracketFilterChips } from "@landing/components/landing/LandingBracketFilterChips"

import { memo, useId } from "react"
import { DemoContent } from "./DemoContent"
import { demoSectionConfig } from "./data/demo-section-config"
import { useDemoCardsState } from "./hooks/use-demo-cards-state"
import { useDemoSectionVisibility } from "./hooks/use-demo-section-visibility"

export const LandingSectionDemo = memo(function LandingSectionDemo() {
  const sectionId = useId()
  const sectionRef = useDemoSectionVisibility()
  const {
    cfbExpanded,
    nflExpanded,
    mlbExpanded,
    ncaabExpanded,
    activeFilter,
    isAnyCardExpanded,
    handleToggleCfb,
    handleToggleNfl,
    handleToggleMlb,
    handleToggleNcaab,
    handleFilterChange: _handleFilterChange,
  } = useDemoCardsState()

  const { classes } = demoSectionConfig

  return (
    <section ref={sectionRef} id={sectionId} className={classes.section}>
      {/* Payout copy removed – duplicate now lives in Bracket section */}
      {/* Desktop Filter Chips - outside scaled container */}
      {/* Keep: Add back when launch happens
      <div className="hidden lg:block mt-2 flex justify-center mb-4 transform lg:scale-[1.09] origin-top">
        <LandingBracketFilterChips activeFilter={activeFilter} onFilterChange={handleFilterChange} />
      </div>
      */}

      {/* Demo Cards */}
      {/*
        Expand bracket card width on mobile:
        1. Remove restrictive `max-w-md` so cards can span the full viewport width.
        2. Eliminate the base `.95` scale to match the native sizing used in the Madness section.
        3. Preserve up-scaled appearance on medium+ screens (was already present).
      */}
      <div className={classes.container}>
        <div className={classes.innerWrapper}>
          {/* Mobile Filter Chips - inside scaled container for proper spacing */}
          {/* Keep: Add back when launch happens
          <div className="lg:hidden mb-5">
            <LandingBracketFilterChips activeFilter={activeFilter} onFilterChange={handleFilterChange} />
          </div>
          */}

          <DemoContent
            activeFilter={activeFilter}
            cfbExpanded={cfbExpanded}
            nflExpanded={nflExpanded}
            mlbExpanded={mlbExpanded}
            ncaabExpanded={ncaabExpanded}
            isAnyCardExpanded={isAnyCardExpanded}
            handleToggleCfb={handleToggleCfb}
            handleToggleNfl={handleToggleNfl}
            handleToggleMlb={handleToggleMlb}
            handleToggleNcaab={handleToggleNcaab}
          />
        </div>
      </div>
    </section>
  )
})
